import { ILogEntry } from 'motw_core/Entity/ILogEntry';

export const ChangeData = async (
	log: ILogEntry[],
	change: {
		row: number;
		column: number;
		data: string;
	}
) => {
	if (!log) throw new Error('missing Log!');

	if (!change) throw new Error('missing change object!');

	let { row, column, data } = change;

	if (row === undefined) throw new Error('Undefined row value');

	if (column === undefined) throw new Error('Undefined column value');

	if (!data) throw new Error('Undefined data');

	// deep clone the log array
	var newLog = JSON.parse(JSON.stringify(log));
	
	throw new Error("TODO: Get this working again");

	// newEntry[column] = data;


	// try {
	// 	await UpdateLogEntryAsync(row, newEntry);
	// 	await UpdateDatapointFromLogEntryAsync(newEntry);
		
	// 	// Update the log (by reference)
	// 	// to allow for multiple log changes (for example, pressing Tab)
	// 	// without having to click 'Reload' for every change
	// 	log.find((entry: ILogEntry) => entry.id === row)!.data[
	// 		column
	// 	] = data;
	// } catch (e) {
	// 	HandleError(e);
	// }
};
